// Function index:
//   startTitleTicker(el) — fetch the PUBLIC world ticker once and rotate its
//       headlines in `el` every 6s ("In <world> — <line> · 2h ago"). Returns
//       a stop(). Renders nothing on error/empty — the ticker is decorative
//       proof-of-life, never a blocker.

import { fetchWorldTicker } from '../../api.js';
import { relTime } from '../../format-time.js';

const ROTATE_MS = 6000;

export function startTitleTicker(el: HTMLElement): () => void {
  let timer: number | null = null;
  let stopped = false;
  void fetchWorldTicker().then(({ entries }) => {
    if (stopped || entries.length === 0) return;
    let i = 0;
    const show = (): void => {
      const e = entries[i % entries.length]!;
      el.textContent = `In ${e.world_name} — ${e.text} · ${relTime(e.created_at)}`;
      i += 1;
    };
    show();
    timer = window.setInterval(show, ROTATE_MS);
  }).catch(() => { /* silent — decorative */ });
  return () => {
    stopped = true;
    if (timer !== null) window.clearInterval(timer);
  };
}
